import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { NotaForm } from "../modais"
import Layout from "../Layout"
class NotasFiscaisEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/contratos")
  }
  render() {
    return (
      <Layout tabActive="Contratos">
        <NotaForm notaCallBack={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(NotasFiscaisEditForm)



// WEBPACK FOOTER //
// ./src/views/baixas/NotasFiscaisEditForm.js